export default __webpack_public_path__ + "static/profile_yoshida-ddeb470b60a9752fff9a1f1ba1242e36.png";